module.exports = __webpack_public_path__ + "assets/49f3f935176773cf9a10984e40e1414f.png";